import { render, staticRenderFns } from "./time-defaultValue-editor.vue?vue&type=template&id=988a5246&scoped=true&"
import script from "./time-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./time-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988a5246",
  null
  
)

export default component.exports